import React, { useState, useEffect } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { DialogActions } from "@material-ui/core";
import { onPreventEnterSubmitting, setObject } from "../../../../utils/utils";
import SearchUser from "../../users/users/searchUser";
import {
  saveLead,
  getLead,
  getLeadMasterDataAPI,
} from "../../../../services/crm/leadService";
import Swal from "sweetalert2";
import DialogLayout from "../../../../partials/content/DialogLayout";
import { Badge, Card } from "react-bootstrap";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import store from "../../../../store/store";
import { DateTime } from "luxon";
import {
  FormSelectField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import MapPlaces from "../../../../partials/content/MapPlaces";
const LeadForm = ({ lead, emailFrom = "", onCloseDialog, onConfirmSave }) => {
  const [auth, setAuth] = useState({});
  const [industryTypeOptions, setIndustryTypeOptions] = useState([]);
  const [businessSizeOptions, setBusinessSizeOptions] = useState([]);
  const [sourceOptions, setSourceOptions] = useState([]);
  const [priorityOptions, setPriorityOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [customerGroupOptions, setCustomerGroupOptions] = useState([]);
  const [openSearchUser, setOpenSearchUser] = useState(false);
  const [openSearchMapPlaces, setOpenSearchMapPlaces] = useState(false);
  const { companyProfile, socket } = useGlobalData();
  const [leadData, setLeadData] = useState({
    ID: 0,
    appCode: "LEAD",
    approvalLvl: 0,
    leadName: "",
    customerGroupID: 1,
    contactName: "",
    position: "",
    contactEmail: emailFrom,
    website: "",
    taxpayerID: "",
    industryTypeID: 0,
    businessSizeID: 0,
    leadValue: "",
    sourceID: 0,
    priorityID: 0,
    contactPhone: "",
    address: "",
    city: "",
    province: "",
    countryCode: companyProfile.countryCode,
    postalCode: "",
    description: "",
    assignedUserID: 0,
    assignedUserName: "",
    public: "",
    leadStatus: 0,
    leadStatusDesc: "",
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  });

  useEffect(() => {
    const { auth } = store.getState();

    async function getLeadData() {
      const response = await getLead(lead.ID);
      const { data, auth } = response.data;
      const {
        lead: leadData,
        businessSize,
        industryType,
        priority,
        source,
        countries,
        customerGroup,
      } = data;
      setMasterData(
        industryType,
        businessSize,
        source,
        priority,
        countries,
        customerGroup
      );
      setLeadData(leadData);
      setAuth(auth);
    }

    async function getLeadMasterData() {
      const response = await getLeadMasterDataAPI();
      const { data, auth } = response.data;
      const {
        businessSize,
        industryType,
        priority,
        source,
        countries,
        customerGroup,
      } = data;
      setMasterData(
        industryType,
        businessSize,
        source,
        priority,
        countries,
        customerGroup
      );
      setAuth(auth);
    }

    getLeadMasterData();

    if (lead && lead.ID > 0) {
      setObject(socket, "lock", lead.ID, "LEAD", auth.user)
        .then((response) => {
          getLeadData();
        })
        .catch((error) => {
          onCloseDialog();
        });
    }
    return () => {
      if (lead && lead.ID > 0) {
        setObject(socket, "release", lead.ID, "LEAD", auth.user);
      }
    };
  }, [lead]);

  const leadFormSchema = yup.object().shape({
    ID: yup.number().default(leadData.ID),
    leadName: yup
      .string()
      .required("Lead Name is required")
      .max(255, "Lead Name maximum characters is 255"),
    contactName: yup
      .string()
      .required("Contact Name is required")
      .max(255, "Contact Name maximum characters is 255"),
    position: yup
      .string()
      .required("Position is required")
      .max(50, "Position maximum characters is 50"),
    website: yup
      .string()
      .matches(
        /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/,
        "Website url must be valid. e.g. https://invifo.com or www.invifo.com"
      )
      .max(50, "Website maximum characters is 50"),
    taxpayerID: yup.string().max(50, "Taxpayer ID maximum characters is 50"),
    leadValue: yup.string(),
    contactPhone: yup
      .string()
      .required("Phone Number is required")
      .matches(
        /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
        "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
      )
      .max(50, "Phone Number maximum characters is 50"),
    contactEmail: yup
      .string()
      .email("Email must be valid. e.g. joe@invifo.com")
      .required("Email is required")
      .max(50, "Email maximum characters is 50"),
    industryTypeName: yup.string(),
    businessSizeName: yup.string(),
    sourceName: yup.string(),
    priority: yup.string(),
    address: yup
      .string()
      .required("Address is required")
      .max(255, "Address maximum characters is 255"),
    city: yup
      .string()
      .required("City is required")
      .max(50, "City maximum characters is 50"),
    province: yup.string().max(50, "Province maximum characters is 50"),
    countryCode: yup.string(),
    postalCode: yup.string().max(10, "Postal Code maximum characters is 10"),
    description: yup.string(),
    assignedUserID: yup.number(),
    assignedUserName: yup.string(),
    public: yup.string(),
  });

  return (
    <Formik
      initialValues={leadData}
      validationSchema={leadFormSchema}
      enableReinitialize={true}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        values.leadValue = parseFloat(values.leadValue);
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Lead ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveLead(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Card>
                <Card.Header>
                  <i className="fas fa-th-large"></i>
                  <span>
                    <strong>Lead Basic Info</strong>
                  </span>
                  {values.ID > 0 ? (
                    <Badge
                      className="float-right ml-1"
                      variant={
                        values.leadStatus === 1
                          ? "primary"
                          : values.leadStatus === 2
                          ? "success"
                          : null
                      }
                    >
                      {values.leadStatus !== 0 ? values.leadStatusDesc : null}
                    </Badge>
                  ) : null}
                </Card.Header>
                <Card.Body>
                  <div className="row">
                    <div className="col-sm-4 col-md-4 col-lg-4">
                      <FormTextField label="Lead Name" name="leadName" />
                      <FormSelectField
                        label="Customer Group"
                        name="customerGroupID"
                        options={customerGroupOptions}
                      />
                      <FormTextField label="Contact Name" name="contactName" />
                      <FormTextField label="Position" name="position" />
                      <FormTextField label="Website" name="website" />
                      <FormTextField
                        label="Taxpayer Identification Number"
                        name="taxpayerID"
                      />
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4">
                      <FormTextField label="Phone Number" name="contactPhone" />
                      <FormTextField
                        label="Email"
                        name="contactEmail"
                        readonly={emailFrom !== "" ? true : false}
                      />
                      <FormSelectField
                        label="Industry Type"
                        name="industryTypeID"
                        options={industryTypeOptions}
                      />
                      <FormSelectField
                        label="Business Size"
                        name="businessSizeID"
                        options={businessSizeOptions}
                      />
                      <FormSelectField
                        label="Source"
                        name="sourceID"
                        options={sourceOptions}
                      />
                      <FormSelectField
                        label="Priority"
                        name="priorityID"
                        options={priorityOptions}
                      />
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4">
                      <FormTextField
                        label="Address"
                        name="address"
                        mapsButton
                        onMapsClick={() => {
                          setOpenSearchMapPlaces(true);
                        }}
                      />
                      <FormTextField label="City" name="city" />
                      <FormTextField label="Province / State" name="province" />
                      <FormSelectField
                        label="Country"
                        name="countryCode"
                        options={countryOptions}
                      />
                      <FormTextField label="Postal Code" name="postalCode" />
                      <FormTextField
                        label="Assigned To"
                        name="assignedUserName"
                        searchButton
                        clearButton
                        onSearchClick={() => {
                          setOpenSearchUser(true);
                        }}
                        onClearFields={() => {
                          setFieldValue(`assignedUserID`, 0);
                          setFieldValue(`assignedUserName`, "");
                        }}
                        readonly
                      />
                    </div>
                  </div>
                  <FormTextField
                    label="Description"
                    name="description"
                    multiline
                    minRows={5}
                  />
                </Card.Body>
              </Card>
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-success btn-md btn-pill btn-bold"
              disabled={isSubmitting}
            >
              <i className="fas fa-save"></i>
              Save
            </button>
          </DialogActions>
          <DialogLayout
            open={openSearchUser}
            title="Search User"
            onCloseDialog={handleCloseSearchUser}
            maxWIdth="lg"
          >
            <SearchUser
              onSelectUser={(user) => {
                setFieldValue(`assignedUserID`, user.ID);
                setFieldValue(
                  `assignedUserName`,
                  user.firstName + " " + user.lastName
                );
                handleCloseSearchUser();
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={handleCloseSearchUser}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchMapPlaces}
            title="Search Address on Maps"
            onCloseDialog={() => {
              setOpenSearchMapPlaces(false);
            }}
            maxWIdth="lg"
            minHeight={true}
          >
            <MapPlaces
              address={values.address}
              city={values.city}
              province={values.province}
              countryCode={values.countryCode}
              postalCode={values.postalCode}
              onPinLocation={(
                selectedFormattedAddress,
                selectedShortAddressComponents,
                selectedLongAddressComponents,
                selectedAddress,
                selectedCity,
                selectedProvince,
                selectedCountryCode,
                selectedPostalCode
              ) => {
                setFieldValue(`address`, selectedAddress);
                setFieldValue(`city`, selectedCity);
                setFieldValue(`province`, selectedProvince);
                setFieldValue(`countryCode`, selectedCountryCode);
                setFieldValue(`postalCode`, selectedPostalCode);
                setOpenSearchMapPlaces(false);
              }}
              onCloseDialog={() => {
                setOpenSearchMapPlaces(false);
              }}
            />
          </DialogLayout>
        </form>
      )}
    </Formik>
  );
  function setMasterData(
    industryTypes = [],
    businessSizes = [],
    sources = [],
    priorities = [],
    countries = [],
    customerGroup = []
  ) {
    let industryTypeOptionsTmp = [];
    let businessSizeOptionsTmp = [];
    let sourceOptionsTmp = [];
    let priorityOptionsTmp = [];
    let countryOptionsTmp = [];
    let customerGroupOptionsTmp = [];
    if (typeof industryTypes !== "undefined") {
      industryTypes.forEach((industryType) => {
        industryTypeOptionsTmp.push({
          value: industryType.ID,
          label: industryType.industryTypeName,
        });
      });
    }

    if (typeof businessSizes !== "undefined") {
      businessSizes.forEach((businessSize) => {
        businessSizeOptionsTmp.push({
          value: businessSize.ID,
          label: businessSize.businessSizeName,
        });
      });
    }

    if (typeof sources !== "undefined") {
      sources.forEach((source) => {
        sourceOptionsTmp.push({
          value: source.ID,
          label: source.sourceName,
        });
      });
    }

    if (typeof priorities !== "undefined") {
      priorities.forEach((priority) => {
        priorityOptionsTmp.push({
          value: priority.ID,
          label: priority.priorityName,
        });
      });
    }

    if (typeof countries !== "undefined") {
      countries.forEach((country) => {
        countryOptionsTmp.push({
          value: country.countryCode,
          label: country.countryName,
        });
      });
    }
    if (typeof customerGroup !== "undefined") {
      customerGroup.forEach((group) => {
        customerGroupOptionsTmp.push({
          value: group.ID,
          label: group.groupName,
        });
      });
    }
    setIndustryTypeOptions(industryTypeOptionsTmp);
    setBusinessSizeOptions(businessSizeOptionsTmp);
    setSourceOptions(sourceOptionsTmp);
    setPriorityOptions(priorityOptionsTmp);
    setCountryOptions(countryOptionsTmp);
    setCustomerGroupOptions(customerGroupOptionsTmp);
  }
  function handleCloseSearchUser() {
    setOpenSearchUser(false);
  }
};
export default LeadForm;
